import { ArrowRight, Zap, Shield, Coins } from "lucide-react";
import { NavLink } from "react-router-dom";
import translator from "../../Components/Extra/Translation/Translate";

export default function NodeSoftware() {
    const { translate } = translator();

    return (
        <div className="min-h-screen py-20 bg-gradient-to-br from-gray-900 via-clisha-888 to-gray-900 text-white overflow-hidden">
            {/* Animated background elements */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div className="absolute w-96 h-96 rounded-full bg-orange-500/10 blur-3xl top-20 -left-48 animate-pulse"></div>
                <div
                    className="absolute w-96 h-96 rounded-full bg-amber-500/10 blur-3xl bottom-20 -right-48 animate-pulse"
                    style={{ animationDelay: "1s" }}
                ></div>
                <div className="absolute w-full h-full opacity-20">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(252,152,40,0.1),transparent_50%)]"></div>
                </div>
                {/* Floating particles */}
                <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-orange-400 rounded-full animate-ping opacity-60"></div>
                <div
                    className="absolute top-3/4 right-1/4 w-1 h-1 bg-amber-400 rounded-full animate-ping opacity-40"
                    style={{ animationDelay: "2s" }}
                ></div>
                <div
                    className="absolute top-1/2 left-3/4 w-1.5 h-1.5 bg-orange-300 rounded-full animate-ping opacity-50"
                    style={{ animationDelay: "3s" }}
                ></div>
            </div>

            {/* Main content */}
            <main className="relative z-10 w-full mx-auto px-6 py-12">
                <div className="max-w-screen-xl mx-auto w-full">
                    {/* Hero section */}
                    <div
                        className={`text-center mb-16 transition-all duration-1000`}
                    >
                        <h1
                            data-aos="fade-left"
                            className="text-4xl md:!text-6xl lg:text-7xl font-bold mb-8 leading-tight"
                        >
                            <span className="block mb-4">
                                {translate("NodeSoftware", "HERO_TITLE_1")}
                            </span>
                            <span className="bg-gradient-to-r from-clisha-500 via-amber-400 to-orange-500 bg-clip-text text-transparent">
                                {translate("NodeSoftware", "HERO_TITLE_2")}
                            </span>
                            <span className="block mt-4 text-3xl md:text-4xl lg:text-5xl">
                                {translate("NodeSoftware", "HERO_SUBTITLE")}
                            </span>
                        </h1>
                    </div>

                    {/* Emotional introduction */}
                    <div
                        className={`max-w-4xl mx-auto mb-16 transition-all duration-1000 delay-300 `}
                        data-aos="fade-right"
                    >
                        <div className="bg-gradient-to-br from-clisha-600 to-clisha-888  backdrop-blur-lg rounded-3xl border border-orange-500/20 p-8 md:p-12 shadow-2xl">
                            <p className="text-xl md:text-2xl leading-relaxed text-center text-gray-200 mb-6">
                                {translate("NodeSoftware", "EMOTIONAL_INTRO_1")}
                            </p>
                            <p className="text-xl md:text-2xl leading-relaxed text-center text-gray-200 mb-6">
                                {translate("NodeSoftware", "EMOTIONAL_INTRO_2")}
                            </p>
                            <p className="text-xl md:text-2xl leading-relaxed text-center">
                                <span className="text-orange-400 font-semibold">
                                    {translate(
                                        "NodeSoftware",
                                        "EMOTIONAL_INTRO_3",
                                    )}
                                </span>
                                <br />
                                {translate("NodeSoftware", "EMOTIONAL_INTRO_4")}
                            </p>
                        </div>
                    </div>

                    {/* Pricing section */}
                    <div
                        className={`mb-16 transition-all duration-1000 delay-500 `}
                    >
                        <h2
                            data-aos="fade-left"
                            className="text-3xl md:text-4xl font-bold text-center mb-12"
                        >
                            <span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">
                                {translate("NodeSoftware", "PRICING_TITLE")}
                            </span>
                        </h2>
                        <div className="grid grid-cols-1 md:!grid-cols-3 gap-6 max-w-7xl mx-auto">
                            <div
                                data-aos="flip-left"
                                className="bg-gradient-to-br from-clisha-600 to-clisha-888 backdrop-blur-lg rounded-2xl border border-orange-500/30 p-8 hover:border-orange-400/50 transition-all duration-300 hover:scale-105"
                            >
                                <div className="flex items-center mb-4">
                                    <Shield className="w-8 h-8 text-orange-400 mr-3" />
                                    <h3 className="text-xl font-semibold text-orange-400">
                                        {translate(
                                            "NodeSoftware",
                                            "ACTIVATION_TITLE",
                                        )}
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-white mb-2">
                                        2.500
                                    </div>
                                    <div className="text-orange-300 text-lg">
                                        USD
                                    </div>
                                    <div className="text-gray-400 text-sm mt-2">
                                        {translate(
                                            "NodeSoftware",
                                            "ACTIVATION_DESC",
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div
                                data-aos="flip-left"
                                className="bg-gradient-to-br from-clisha-600 to-clisha-888 backdrop-blur-lg rounded-2xl border border-orange-500/30 p-8 hover:border-orange-400/50 transition-all duration-300 hover:scale-105"
                            >
                                <div className="flex items-center mb-4">
                                    <Zap className="w-8 h-8 text-orange-400 mr-3" />
                                    <h3 className="text-xl font-semibold text-orange-400">
                                        {translate(
                                            "NodeSoftware",
                                            "SERVICE_TITLE",
                                        )}
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-white mb-2">
                                        75
                                    </div>
                                    <div className="text-orange-300 text-lg">
                                        USD
                                    </div>
                                    <div className="text-gray-400 text-sm mt-2">
                                        {translate(
                                            "NodeSoftware",
                                            "SERVICE_DESC",
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div
                                data-aos="flip-left"
                                className="bg-gradient-to-br from-clisha-600 to-clisha-888 backdrop-blur-lg rounded-2xl border border-orange-500/30 p-8 hover:border-orange-400/50 transition-all duration-300 hover:scale-105"
                            >
                                <div className="flex items-center mb-4">
                                    <Coins className="w-8 h-8 text-orange-400 mr-3" />
                                    <h3 className="text-xl font-semibold text-orange-400">
                                        {translate(
                                            "NodeSoftware",
                                            "WALLET_TITLE",
                                        )}
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <div className="text-4xl font-bold text-white mb-2">
                                        500
                                    </div>
                                    <div className="text-orange-300 text-lg">
                                        USDT
                                    </div>
                                    <div className="text-gray-400 text-sm mt-2">
                                        {translate(
                                            "NodeSoftware",
                                            "WALLET_DESC",
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p
                            data-aos="fade-left"
                            className="text-center text-gray-400 mt-6 max-w-3xl mx-auto"
                        >
                            {translate("NodeSoftware", "PRICING_NOTE")}
                        </p>
                    </div>

                    {/* Final motivating phrase */}
                    <div
                        className={`text-center mb-12 transition-all duration-1000 delay-700`}
                    >
                        <p
                            data-aos="fade-right"
                            className="text-2xl md:text-3xl font-bold"
                        >
                            <span className="bg-gradient-to-r from-orange-400 via-amber-400 to-orange-500 bg-clip-text text-transparent">
                                {translate("NodeSoftware", "MOTIVATION_1")}
                            </span>
                            <br />
                            <span className="text-white">
                                {translate("NodeSoftware", "MOTIVATION_2")}
                            </span>
                        </p>
                    </div>

                    {/* Call to action */}
                    <div
                        data-aos="zoom-in"
                        className={`text-center transition-all duration-1000 delay-900 `}
                    >
                        <NavLink
                            to="/login-node-software"
                            className="group relative inline-flex items-center justify-center px-12 py-6 text-xl font-bold text-white bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 rounded-2xl hover:from-orange-400 hover:via-amber-400 hover:to-orange-500 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/25 focus:outline-none focus:ring-4 focus:ring-orange-500/50"
                        >
                            <span className="relative z-10 mr-3">
                                {translate("NodeSoftware", "CTA_BUTTON")}
                            </span>
                            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300" />

                            {/* Button glow effect */}
                            <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-300"></div>
                        </NavLink>
                    </div>
                </div>
            </main>
        </div>
    );
}
